import React, { useEffect } from "react"
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const bdLandingPageRoute = t("bdLandingPageRedirectionLink");
    navigate(bdLandingPageRoute);
  }, [navigate]);

  return <p> Redirecting to Business Directory Landing Page... </p>
}

export default Home;